/* eslint-disable camelcase */
import moment from 'moment';

const save = (eventName, dlurl) => {
    const a = document.createElement('a');
    a.href = dlurl;
    a.target = '_blank';
    a.download = eventName ? `${eventName}.ics` : 'unknown';
    const evt = new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: false,
    });
    a.dispatchEvent(evt);
    // (window.URL || window.webkitURL).revokeObjectURL(save.href);
};

export const createIcal = (eventName, schedule) => {
    const ics_lines = [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'PRODID:-//MyUTR//Events//EN',
        'METHOD:REQUEST',
        'BEGIN:VEVENT',
        'UID:event',
        `DTSTAMP:${moment().format('YYYYMMDDTHHmmss[Z]')}`,
        `DTSTART:${moment(schedule.eventStartUtc).format('YYYYMMDDTHHmmss[Z]')}`,
        `DTEND:${moment(schedule.eventEndUtc).format('YYYYMMDDTHHmmss[Z]')}`,
        `DESCRIPTION:${eventName}`,
        `SUMMARY:${eventName}`,
        `LAST-MODIFIED:${moment().format('YYYYMMDDTHHmmss[Z]')}`,
        'SEQUENCE:0',
        'END:VEVENT',
        'END:VCALENDAR',
    ];
    const dlurl = `data:text/calendar;base64,${btoa(ics_lines.join('\r\n'))}`;
    try {
        save(eventName, dlurl);
    } catch (e) {
        console.log(e);
    }
};

export const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
export const daysPerMonth = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
export const daysOfWeek = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

export const getYearOptions = () => {
    let years = Array.from(new Array(moment().year() - 1899), (x, i) => i + 1900);
    years = years.sort((a, b) => b - a);
    return years;
};

export const getDayOptions = (days) => {
    return Array.from(new Array(days || 30), (x, i) => i + 1);
};
